/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import RatingsBreakdown from 'bundles/reviews-common/components/cds/RatingsBreakdown';
import type { RatingCountsByStar } from 'bundles/reviews-common/components/cds/RatingsBreakdown';

import _t from 'i18n!nls/reviews-common';

type Props = {
  averageFiveStarRating?: number | null;
  ratingCount?: number | null;
  ratingCountsByStar?: RatingCountsByStar | null;
  // Set for a specialization/professional certificate, whose rating is an average across its
  // child courses rather than a single course's own rating.
  numberOfCourses?: number;
};

const styles = {
  card: css`
    background: var(--cds-color-neutral-background-primary);
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: 20px;
    padding: var(--cds-spacing-300);
  `,
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const ReviewsRatingCard = ({ averageFiveStarRating, ratingCount, ratingCountsByStar, numberOfCourses }: Props) => {
  if (!ratingCountsByStar) {
    return null;
  }

  return (
    <section css={styles.card} aria-labelledby="rating-title">
      <Typography2 variant="subtitleLarge" component="h2" css={styles.title} id="reviews-rating-title">
        {_t('Overall rating')}
      </Typography2>
      <RatingsBreakdown
        averageFiveStarRating={averageFiveStarRating}
        ratingCount={ratingCount}
        ratingCountsByStar={ratingCountsByStar}
        numberOfCourses={numberOfCourses}
        useSingleLineCenteredSummary
      />
    </section>
  );
};

export type { RatingCountsByStar };
export default ReviewsRatingCard;
